/**
 * Session lifecycle (spec §4). Only the orchestrator writes state; every change
 * is also recorded as a `state_change` event so Discord and the dashboard agree.
 */
export const SESSION_STATES = [
  "created",
  "queued",
  "idle",
  "working",
  "waiting",
  "done",
  "rate_limited",
  "stopped",
  "errored",
] as const;

export type SessionState = (typeof SESSION_STATES)[number];

/** States in which a runner process is expected to be alive. */
export const LIVE_STATES: readonly SessionState[] = ["idle", "working", "waiting", "done", "rate_limited"];

/** States in which a new prompt can be sent straight to the runner (otherwise it queues). */
export const READY_STATES: readonly SessionState[] = ["idle", "done"];

export const STATE_LABELS: Record<SessionState, string> = {
  created: "Created",
  queued: "Queued",
  idle: "Idle",
  working: "Working",
  waiting: "Waiting on you",
  done: "Done",
  rate_limited: "Rate limited",
  stopped: "Stopped",
  errored: "Errored",
};

export function isLive(state: SessionState): boolean {
  return LIVE_STATES.includes(state);
}
